import * as actionTypes from '../actions/actionTypes';


export default function customerAdminReducer(state = {}, action) {
    switch(action.type){
      case actionTypes.SET_CUSTOMER_ADMIN_DETAIL:
        return {
          ...state,
          ...action.data
        }

      default: return state;

    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/customerAdminReducer.js